import Image from 'next/image';
import type { FeatureStill } from '@/types/feature-media';
import ProductMediaFrame from './ProductMediaFrame';

export default function FeatureStillMedia({ media }: { media: FeatureStill }) {
  return (
    <figure
      className="relative w-full self-center px-3 py-8 sm:px-6"
      data-testid="feature-still-media"
      data-section-id={media.sectionId}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 inset-y-12 rounded-[48px] bg-gradient-to-br from-[var(--color-theme)]/15 via-[var(--color-theme)]/5 to-transparent"
      />
      <ProductMediaFrame
        frame={media.frame}
        width={media.width}
        height={media.height}
      >
        <Image
          src={media.src}
          alt={media.alt}
          fill
          sizes={
            media.frame === 'phone'
              ? '(max-width: 390px) 80vw, 330px'
              : '(max-width: 1024px) 90vw, 600px'
          }
          className="object-contain"
        />
      </ProductMediaFrame>
      {media.caption && (
        <figcaption className="relative mx-auto mt-6 max-w-md text-center text-sm leading-6 text-[var(--color-foreground-secondary)]">
          {media.caption}
        </figcaption>
      )}
    </figure>
  );
}
